import { useEffect, useRef, useState } from 'react';

const prefersReducedMotion = typeof window !== 'undefined'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

export default function useScrollReveal(threshold = 0.15, disabled = false) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(disabled || prefersReducedMotion);

    useEffect(() => {
        if (disabled || prefersReducedMotion) { setVisible(true); return; }
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.unobserve(el); } },
            { threshold }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [threshold, disabled]);

    return [ref, visible];
}

export { prefersReducedMotion };
